export const LANGUAGE_STORAGE_KEY = "blog-language";

export const getSavedLanguage = () => {
  try {
    return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) === "ko" ? "ko" : "en";
  } catch {
    return "en";
  }
};

export const labels = {
  en: {
    home: "home",
    blog: "Blog",
    language: "Reading language",
    notFound: "Post not found",
    selectPost: "Please select a valid post from the blog list.",
  },
  ko: {
    home: "홈",
    blog: "블로그",
    language: "읽기 언어",
    notFound: "글을 찾을 수 없습니다",
    selectPost: "블로그 목록에서 글을 선택해 주세요.",
  },
};

export const localizePost = (post, language) => ({
  ...post,
  content: post.translations?.[language]?.content ?? post.content,
});
